import React, { useEffect, useState } from "react";
import { decodeJwt } from "jose";
import { IProps } from "./types/IProps";
import { useAuthService } from "../../../use-cases/auth";

export const PrivateRoute: React.FC<IProps> = (props) => {
  const token = localStorage.getItem('ACCESS_TOKEN');
  const { insertAcesso } = useAuthService();
  const [isReady, setIsReady] = useState(false);

  const getLoginUrl = () => {
    return (
      process.env.REACT_APP_VELES_LOGIN_URL ||
      (process.env.REACT_APP_VELES_MODULES_URL || '').replace('/modulos', '/authentication/login')
    );
  };

  useEffect(() => {
    let isMounted = true;

    const checkAcesso = async () => {
      if (!token) {
        window.location.replace(getLoginUrl());
        return;
      }

      try {
        const decoded = decodeJwt(token) as { exp?: number; IdAcesso?: number };
        if (decoded.exp && decoded.exp * 1000 <= Date.now()) {
          localStorage.removeItem('ACCESS_TOKEN');
          window.location.replace(getLoginUrl());
          return;
        }

        // Se o token ainda não tem IdAcesso, obtém registrando o acesso
        if (!decoded.IdAcesso) {
          try {
            await insertAcesso(14);
          } catch (e) {
            console.error('Falha ao registrar IdAcesso no PrivateRoute:', e);
            localStorage.removeItem('ACCESS_TOKEN');
            window.location.replace(getLoginUrl());
            return;
          }
        }

        if (isMounted) {
          setIsReady(true);
        }
      } catch {
        localStorage.removeItem('ACCESS_TOKEN');
        window.location.replace(getLoginUrl());
      }
    };

    checkAcesso();

    return () => {
      isMounted = false;
    };
  }, [token, insertAcesso]);

  if (!isReady) {
    return null;
  }

  return <>{props.children}</>;
};